import React from "react";

function PageNotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background text-center">
      <h1 className="text-6xl leading-normal text-heading-color">Oops!</h1>
      <p className="text-2xl text-heading-color">
        Seems like you have entered the wrong link
      </p>
    </div>
  );
}

export default PageNotFound;
